import styled from "styled-components";

export const NavStyle = styled.div`
  .hamburger {
    display: none;
    cursor: pointer;
    position: fixed;
    top: 11vh;
    left: 10px;
    z-index: 3;
  }

  .crossStyle {
    color: white;
    font-size: 17px;
  }
  .hamburger span {
    display: block;
    height: 2px;
    width: 25px;
    margin-bottom: 5px;
    position: relative;
    background: #f28809;
    border-radius: 3px;
    z-index: 3;
  }

  .hamburger span:last-child {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 768px) {
    .hamburger {
      display: block;
    }
  }

  .left-sidebar {
    font-family: light-pro, sans-serif;
    top: 0;
    left: -200px;
    bottom: 0;
    width: 30%;
    height: 100vh;
    z-index: 2;
    margin-top: 10vh;
    background: radial-gradient(
        50% 50% at 50% 50%,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0) 100%
      ),
      #161616;
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
    border-radius: 0px 10px 10px 0px;
    position: fixed;
    transition: all 0.3s ease;
    color: white;
    padding: 20px 30px 150px 20px;
    overflow-y: auto;
    /* Set the width and height of the scroll bar */
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    /* Style the background of the scroll bar */
    ::-webkit-scrollbar-track {
      background-color: white;
    }

    /* Style the thumb of the scroll bar */
    ::-webkit-scrollbar-thumb {
      background-color: #f28809;
      border-radius: 5px;
    }

    /* Style the thumb of the scroll bar on hover */
    ::-webkit-scrollbar-thumb:hover {
      background-color: #373634;
    }

    /* Set the width and height of the scroll bar */
    scrollbar-width: thin;
    scrollbar-color: #f28809 white;

    /* Style the thumb of the scroll bar */
    ::-moz-scrollbar-thumb {
      background-color: white;
      border-radius: 5px;
    }

    /* Style the thumb of the scroll bar on hover */
    ::-moz-scrollbar-thumb:hover {
      background-color: #f28809;
    }
  }

  .left-sidebar.open {
    left: 0 !important;
    transition: transform 0.3s ease-in-out;
  }

  .text-node {
    cursor: pointer;
    font-family: light-pro, sans-serif;
    margin: 0 !important;
  }

  .div1 {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: bold;
  }
  .div2 {
    display: flex;
    align-items: center;
  }

  .node-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .sign {
    margin-right: 5px;
  }

  .toggle-btn {
    position: fixed;
    top: 10px;
    left: 210px;
    font-size: 1.5rem;
    color: #fff;
    background-color: transparent;
    border: none;
    cursor: pointer;
  }

  .toggle-btn:focus {
    outline: none;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }

  a {
    display: block;
    padding: 10px;
    color: #fff;
    text-decoration: none;
  }

  a:hover {
    background-color: #555;
  }

  .node {
    color: white;
  }

  .search-bar {
    display: flex;
    align-items: center;
    border: 1px solid #f28809;
    border-radius: 20px;
    width: 100%;
    background-color: white;
    padding: 0 15px 0 5px;
    margin-bottom: 10px;
  }

  .search-input {
    flex: 1;
    border: none;
    outline: none;
    padding: 5px;
    border-radius: 20px;
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    /* color: var(--bs-dropdown-link-hover-color); */
    color: white;
    /* background-color: var(--bs-dropdown-link-hover-bg); */
    background-color: #ed9e44;
    cursor: pointer;
  }

  .btn-sort {
    background-color: transparent;
    border: none;
    padding: 0;
  }

  .sort-div {
    display: flex;
    justify-content: space-between;
  }
  .search-icon {
    color: #f28809;
    font-size: 20px;
    cursor: pointer;
  }
  .tree-main {
    width: 100%;
  }

  .tree-main2 {
    width: 90%;
    padding-top: 15px;
  }
  .sort-icon {
    font-size: 21px;
  }
  .btn-div {
    margin-bottom: 10px;
    font-family: light-pro, sans-serif;
    margin-left: 5px;
  }

  .btn-active-div {
    background-color: #f28809;
    font-family: light-pro, sans-serif;
  }
  .selected-sort {
    background-color: #f28809;
    color: white;
  }
  .filter-btn {
    font-size: 0.75rem;
  }

  .searchtxt {
    font-size: 1rem;
    font-family: light-pro, sans-serif;
  }

  .filter-div {
    display: flex;
    align-items: baseline;
  }

  /* For large devices */
  @media screen and (max-width: 2560px) {
    .left-sidebar {
      width: 22%;
    }
  }
  @media screen and (max-width: 1440px) {
    .left-sidebar {
      width: 30%;
    }
    .filter-btn {
      font-size: 0.7rem;
    }

    .searchtxt {
      font-size: 0.8rem;
    }
  }
  @media screen and (max-width: 1024px) {
    .left-sidebar {
      width: 30%;
      padding: 20px 15px 80px 15px;
    }

    .filter-btn {
      font-size: 0.67rem;
    }
    .searchtxt {
      font-size: 0.7rem;
    }
    .search-bar {
      padding: 0px 10px 0px 5px;
    }
  }
  @media only screen and (max-width: 800px) {
    .left-sidebar {
      left: -200px;
      width: 42%;
      padding: 35px 10px 100px 20px;
    }
  }

  @media only screen and (max-width: 450px) {
    .left-sidebar {
      width: 98%;
    }
  }
`;

export const CircleStyle = styled.div`
  display: ${({ display }) => display};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  align-self: center;
  background-color: ${({ color }) => color};
  // animation: glowing 1500ms infinite;
  @keyframes glowing {
    0% {
      box-shadow: 0 0 3px white;
    }
    50% {
      box-shadow: 0 0 6px white;
    }
    100% {
      box-shadow: 0 0 3px white;
    }
  }
`;
